<template>
  <div class="game-list">
    <div class="game-grid">
      <game-card
        v-for="(game, index) in games.slice(0, 6)"
        :key="game.id"
        :game="game"
        :image-url="imageUrl"
        :query-string="queryString"
        :rank="index + 1"
      />
    </div>
  </div>
</template>

<script>
import GameCard from './game-card-mobile.vue'

export default {
  name: 'GameList',
  components: {
    GameCard
  },
  props: {
    games: {
      type: Array,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    queryString: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.game-list {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 0 30px 30px 30px;

  .game-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 80px 60px;
    padding: 30px 0;
  }
}

@media (max-width: 768px) {
  .game-list {
    padding: 0 20px 20px 20px;

    .game-grid {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(3, 1fr);
      gap: 40px 30px;
      padding: 20px 0;
    }
  }
}

@media (max-width: 480px) {
  .game-list {
    padding: 0 15px 15px 15px;

    .game-grid {
      gap: 25px 20px;
      padding: 15px 0;
    }
  }
}
</style>